import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env';

export const apimInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.startsWith(environment.apiConfig.uri)) {
    const cloned = req.clone({
      setHeaders: {
        'Ocp-Apim-Subscription-Key': environment.apiConfig.subscriptionKey,
      },
    });
    return next(cloned);
  }
  return next(req);
};
